import React, { useEffect, useState } from "react";
import "./CustomerDetails.scss";

import { MdOutlineFileDownload } from "react-icons/md";
import { RiCoinsFill } from "react-icons/ri";

import { Link, useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import {
  fetchOrdersByCustomer,
  fetchPurchasesByCustomer,
} from "../../../api/customers";
import Loader from "../../../components/Loader/Loader";
import { format, parseISO } from "date-fns";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { prepareAndDownloadCSV } from "../../../helpers/exportSales";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";
import { IoIosArrowBack } from "react-icons/io";
import StoreCredit from "../StoreCredit/StoreCredit";
import SalesDetails from "../../Sales/SalesDetails/SalesDetails";
import PDF from "../../PDF/PDF";

const CustomerDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentViewPort } = useViewPortDetector();

  const customerData = location.state?.customerData || {};
  const customer_id = customerData?.id || null;

  const { id: organization_id, currency } = useSelector(
    (state) => state.organizationReducer.value
  );

  const [loading, setLoading] = useState(false);
  const [customerPurchases, setCustomerPurchases] = useState([]);
  const [customerOrders, setCustomerOrders] = useState([]);

  const [selectedTab, setSelectedTab] = useState("purchases");

  const [totalDataSales, setTotalDataSales] = useState({
    amount: 0,
    sales: 0,
  });

  const [totalDataOrders, setTotalDataOrders] = useState({
    amount: 0,
    sales: 0,
  });

  const [csvSalesBlob, setCsvSalesBlob] = useState(null);
  const [csvOrdersBlob, setCsvOrdersBlob] = useState(null);

  const [isScrolling, setIsScrolling] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const [selectedSale, setSelectedSale] = useState(null);
  const [selectedDesktopTag, setSelectedDesktopTag] = useState(
    "Store Credit History"
  );

  const handleScroll = (e) => {
    const currentScrollTop = e.target.scrollTop;

    setIsScrolling(currentScrollTop > lastScrollY);

    setLastScrollY(currentScrollTop);
  };

  const getCustomerPurchases = () => {
    fetchPurchasesByCustomer(customer_id)
      .then((res) => {
        if (res.data?.length > 0) {
          setCustomerPurchases(res.data);
          const blob = prepareAndDownloadCSV(res.data, "sales");
          setCsvSalesBlob(blob);
        } else {
          setCustomerPurchases([]);
          setCsvSalesBlob(null);
        }
      })
      .catch((err) => {
        console.log("Error while fetching customer's purchases.");
      });
  };

  const getCustomerOrders = () => {
    fetchOrdersByCustomer(customer_id)
      .then((res) => {
        if (res.data?.length > 0) {
          setCustomerOrders(res.data);
          const blob = prepareAndDownloadCSV(res.data, "orders");
          setCsvOrdersBlob(blob);
        } else {
          setCustomerOrders([]);
          setCsvOrdersBlob(null);
        }
      })
      .catch((err) => {
        console.log("Error while fetching customer's orders.");
      });
  };

  useEffect(() => {
    if (!customer_id) {
      navigate(ROUTES.customers.path);
    } else {
      setLoading(true);
      getCustomerPurchases();
      getCustomerOrders();
      setLoading(false);
    }
  }, [customer_id]);

  useEffect(() => {
    let temp_total = 0;
    let temp_sales = 0;

    customerPurchases?.forEach((el) => {
      temp_total += el?.total_amount;
      temp_sales += 1;
    });

    setTotalDataSales({
      amount: Number(temp_total).toFixed(2),
      sales: temp_sales,
    });
  }, [customerPurchases]);

  useEffect(() => {
    let temp_total = 0;
    let temp_sales = 0;

    customerOrders?.forEach((el) => {
      temp_total += el?.total_amount;
      temp_sales += 1;
    });

    setTotalDataOrders({
      amount: Number(temp_total).toFixed(2),
      sales: temp_sales,
    });
  }, [customerOrders]);

  const handleDownloadSales = () => {
    if (!csvSalesBlob) {
      return toast.dismiss(); toast.info("No data to export.");
    }

    const url = window.URL.createObjectURL(csvSalesBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "customer-sales.csv";
    link.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadOrders = () => {
    if (!csvOrdersBlob) {
      return toast.dismiss(); toast.info("No data to export.");
    }

    const url = window.URL.createObjectURL(csvOrdersBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "customer-orders.csv";
    link.click();

    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    setIsScrolling(false);
  }, [selectedTab]);
  return (
    <>
      {loading && <Loader />}
      <div className="page-with-side-components">
        <div className="customer-details-page">
          <div className="desktop-navbar">
            <div
              className="back"
              onClick={() => {
                navigate(ROUTES.customers.path, {
                  state: { customerSelected: customerData },
                });
              }}
            >
              <IoIosArrowBack />
            </div>
            <p>{ROUTES.customerDetails.title}</p>
          </div>
          <div className="top-tab">
            {["purchases", "orders"].map((item, i) => {
              return (
                <div
                  className={selectedTab === item && "active"}
                  key={i}
                  onClick={() => {
                    if (selectedTab !== item) {
                      setSelectedTab(item);
                    }
                  }}
                >
                  <p>{item}</p>
                </div>
              );
            })}
          </div>

          <div className="customer-details">
            <p className="title container-wrapper">
              {selectedTab} for {customerData?.name || "N/A"}
            </p>

            {selectedTab === "purchases" && (
              <div
                className="purchases-list container-wrapper"
                onScroll={handleScroll}
              >
                {customerPurchases.map((item, i) => {
                  let items = 0;
                  item?.products?.forEach((el) => {
                    items += Number(el?.pivot?.quantity || 0);
                  });
                  let return_items = 0;
                  item?.products?.forEach((el) => {
                    return_items += Number(el?.return?.quantity || 0);
                  });
                  return (
                    <div
                      className="item pointer"
                      key={i}
                      onClick={() => {
                        if (currentViewPort === "mobile") {
                          navigate(ROUTES.salesDetails.path, {
                            state: {
                              item: item,
                              customerData: customerData,
                              isOrder: false,
                            },
                          });
                        } else {
                          setSelectedSale(item);
                          setSelectedDesktopTag("Sales Details");
                        }
                      }}
                    >
                      <p className="title">
                        Date:{" "}
                        {item?.updated_at
                          ? format(parseISO(item?.updated_at), "dd/MM/yyyy")
                          : ""}
                      </p>
                      <p>
                        Total: {currency}
                        {Number(item?.total_amount).toFixed(2)} - Items: {items}{" "}
                        {return_items ? `- Returned: ${return_items}` : ""}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}

            {selectedTab === "orders" && (
              <div
                className="purchases-list container-wrapper"
                onScroll={handleScroll}
              >
                {customerOrders.map((item, i) => {
                  let items = 0;
                  item?.products?.forEach((el) => {
                    items += el?.pivot?.quantity;
                  });
                  item?.non_inventory_items?.forEach((el) => {
                    items += el?.quantity;
                  });
                  return (
                    <div className="item" key={i}>
                      <p className="title">
                        Date:{" "}
                        {item?.updated_at
                          ? format(parseISO(item?.updated_at), "dd/MM/yyyy")
                          : ""}
                      </p>
                      <p>
                        Total: {currency}
                        {Number(item?.total_amount).toFixed(2)} - Items: {items}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <div
            className={`download-sales-csv ${isScrolling ? "inactive" : ""}`}
          >
            <p>
              {currency}
              {selectedTab === "orders"
                ? totalDataOrders.amount
                : totalDataSales.amount}{" "}
              from{" "}
              {selectedTab === "orders"
                ? totalDataOrders.sales
                : totalDataSales.sales}{" "}
              {selectedTab === "orders" ? "orders" : "sales"}.
            </p>
            <div
              className="svg"
              onClick={() => {
                if (selectedTab === "orders") {
                  handleDownloadOrders();
                } else {
                  handleDownloadSales();
                }
              }}
            >
              <MdOutlineFileDownload />
            </div>
          </div>

          <Link
            to={
              currentViewPort === "mobile"
                ? ROUTES.customerStoreCredit.path
                : "#"
            }
            state={{ customerData: customerData }}
            className={`store-credit-details ${isScrolling ? "inactive" : ""}`}
            onClick={() => {
              if (currentViewPort === "desktop") {
                setSelectedDesktopTag("Store Credit History");
              }
            }}
          >
            <div className="left">
              <RiCoinsFill />
              <p>
                {currency}
                {Number(customerData?.current_balance).toFixed(2)}
              </p>
            </div>
            <div className="right">
              <p className="heading">Store Credit Available</p>
              <p className="content">Store Credit Expiring on 11/30/2024</p>
            </div>
          </Link>

          <div
            className="navigation-back-button"
            onClick={() => {
              navigate(ROUTES.customers.path, {
                state: { customerSelected: customerData },
              });
            }}
          >
            <IoIosArrowBack />
          </div>
        </div>
        <div className="right-desktop-view">
          <div className="desktop-navbar border-bottom box-shadow">
            {selectedDesktopTag !== "Store Credit History" && (
              <div
                className="back"
                onClick={() => {
                  if (selectedDesktopTag === "PDF") {
                    setSelectedDesktopTag("Sales Details");
                  } else {
                    setSelectedDesktopTag("Store Credit History");
                  }
                }}
              >
                <IoIosArrowBack />
              </div>
            )}
            <p>{selectedDesktopTag}</p>
          </div>

          <StoreCredit
            desktopView={true}
            selected={customerData}
            open={selectedDesktopTag === "Store Credit History"}
          />

          {selectedDesktopTag === "Sales Details" && (
            <SalesDetails
              desktopView={true}
              sale={selectedSale}
              setSelectedDesktopTag={setSelectedDesktopTag}
            />
          )}

          {selectedDesktopTag === "PDF" && <PDF id={selectedSale?.id} />}
        </div>
      </div>
    </>
  );
};

export default CustomerDetails;
